import ReleaseRentWithoutInvoiceError from './ReleaseRentWithoutInvoiceError';
class CouldNotReleaseAmount extends ReleaseRentWithoutInvoiceError {
    constructor(options) {
        super('The requested amount could not be released', options);
    }
}
export default CouldNotReleaseAmount;
